import React from 'react';
import Button from '@mui/material/Button';

interface ISubmitButtonProps {
    text: string;
    id: string
    loading: boolean;
    loadingText: string;
}

const SubmitButton = (submitButtonProps: ISubmitButtonProps) => {
    return (
        <Button
            id={submitButtonProps.id}
            sx={{ m: 1, p: 1, mt: 2, alignSelf: "end" , width:"50%" }}
            type='submit'
            variant='contained'
            disabled={submitButtonProps.loading}>
            {submitButtonProps.loading ? submitButtonProps.loadingText : submitButtonProps.text}
        </Button>
    )
}

export default SubmitButton;